import { render, staticRenderFns } from "./bo-cell-currency.vue?vue&type=template&id=f8de65ac"
import script from "./bo-cell-currency.vue?vue&type=script&lang=js"
export * from "./bo-cell-currency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports